import { AdminAppState, AuthState } from '../../state';
import { getAuth } from './get-auth';

export const getAuthAccessToken = (
  store: AdminAppState,
): AuthState['accessToken'] => getAuth(store).accessToken;
